export default __webpack_public_path__ + "24560c33489424fe301f04d9a44653cf.png";